import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { providePlatformConfig } from '../../../libs/platform-config/src';
import { GlobalErrorHandler } from '../../../libs/platform-core/src';
import { providePlatformTheme } from '../../../libs/platform-theme/src';
import { providePlatformI18n } from '../../../libs/platform-i18n/src';
import { routes } from '../router/app.routes';
import { environment } from '../environments/environment.dev';
import { deepMerge } from '../../../libs/platform-config/src';
import { defaultConfig } from '../../../libs/platform-config/src';
import { DISABLED_MATCHER_PROVIDER, ENABLED_MATCHER_PROVIDER, HIDDEN_MATCHER_PROVIDER, REQUIRED_MATCHER_PROVIDER, VISIBLE_MATCHER_PROVIDER } from '@platform/dynamic';
import { authInterceptor } from '../interceptors/authInterceptor';
import { errorInterceptor } from '../interceptors/errorInterceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      withEnabledBlockingInitialNavigation()
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, errorInterceptor])
    ),
    // Provide platform configuration with environment overrides (must be before UI provider)
    providePlatformConfig(environment),
    // Provide platform i18n (must be after config provider and HttpClient)
    providePlatformI18n(),
    // Provide platform theme (PrimeNG theme and configuration)
    // This will use the platform config that was just provided
    providePlatformTheme(deepMerge({ ...defaultConfig }, environment)),
    // Provide global error handler
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    // Provide PrimeNG services for Toast, ConfirmDialog, ConfirmPopup, DynamicDialog
    MessageService,
    ConfirmationService,
    DialogService,
    DISABLED_MATCHER_PROVIDER,
    ENABLED_MATCHER_PROVIDER,
    HIDDEN_MATCHER_PROVIDER,
    VISIBLE_MATCHER_PROVIDER,
    REQUIRED_MATCHER_PROVIDER
  ],
};

